import { Injectable } from '@angular/core';
import { v1 as uuid } from 'uuid';

import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';
import { LayerCategory } from './field-mapping.service';
import { AppSettings } from './../app.settings';
import { CommonUtilityService } from './common-utility.service';
import { FilterOperatorName } from './gfo.service';
import { InterlayerReportType } from './interlayer-report.service';
// import { v1 } from 'uuid/interfaces';

// Possible column type in gdo
export type LbColumnType = 'number' | 'text' | 'date' | 'bool' | 'jsonb' | 'xml' | 'USER-DEFINED';
// General column types used as lb standard
export type GeneralColType = 'numeric' | 'text' | 'date' | 'bool' | 'jsonb' | 'uuid';

export interface DataColumn {
	name: string; // column name
	heading: string; // column displayed name
	width: number; // width in pixel
	type: LbColumnType; // column type
	sourceTab: string; // source tab
	align: 'C' | 'L' | 'R'; // text-align. 'C' for center, 'L' for left, 'R' for right
	isDisplay: boolean; // display or hide column. 'Y' | 'N'
	isPrimeKey: boolean; // is prime key or not
	isGto: boolean; // ???
	seq: number; // column sequence for displaying
	fkCol?: string;
	fkTab?: string;
}

export interface LBRole {
	default: boolean;
	desc: string;
	rol_id: number;
}
type LayerState = 'create' | 'qc' | 'submit' | 'disapprove' | 'approve' | 'delete' | 'purge'; // 'load'

export interface AzgivSampleAddress {
	Address_Example: string;
	Address_Num: {
		Add_Number;
		AddNum_Pre;
		AddNum_Suf;
	};
	Address_Other: {
		Unit;
	};
	Road_Name: {
		St_Name;
		St_PosDir;
		St_PosMod;
		St_PosTyp;
		St_PreDir;
		St_PreMod;
		St_PreSep;
		St_PreTyp;
	}
}

export interface CustomerProfile {
	discrepancyAgencyId;
	// centroidLatlong: number[];
}

export interface ReportType {
	label: string;
	value: InterlayerReportType;
}

export interface ColumnNagParam {
	standardName: string;
	nctId: number;
	isSpatial: boolean;
	source?: string;
	nctName: string;
	// subcates?: string;
}

@Injectable()
export class AppinfoService {

	public layerTypeList: LayerCategory[] = [];
	reportTypeList: ReportType[] = [];

	public columnMap: {
		[colName: string]: DataColumn
	} = {};

	public rolesByApp: {
		[prop: string]: LBRole[];
	} = {};
	public layerStateMap: {
		[state in LayerState]?: string
	} = {};
	public filterOperators: {[type in FilterOperatorName]?: { name: FilterOperatorName; label: string; compatibleColTypes: GeneralColType[]; sq: number;}} = {};
	public lbDataTypesMap: {
		[colType in GeneralColType]?: string[];
	};

	refLayerMvtAttrs: {
		[cateCode: string]: {
			[model: string]: {
				model: 'N' | 'L',
				attrList: string;
			};
		}
	} = {};

	public sampleAddresses: {
		Common: AzgivSampleAddress[];
		Rare: AzgivSampleAddress[];
	};

	nagParams: ColumnNagParam[] = [];
	nagPostypeCrosswalk: {
		[postype: string]: {
			postType;
			nena;
			usps;
			cusId;
		}
	};
	nagDirectionCrosswalk: {
		[direction: string]: {
			nena: string;
			usps: string;
		}
	} = {
		N: {
			nena: 'NORTH',
			usps: 'N'
		},
		NORTH: {
			nena: 'NORTH',
			usps: 'N'
		},
		NW: {
			nena: 'NORTHWEST',
			usps: 'NW'
		},
		NORTHWEST: {
			nena: 'NORTHWEST',
			usps: 'NW'
		},
		NE: {
			nena: 'NORTHEAST',
			usps: 'NE'
		},
		NORTHEAST: {
			nena: 'NORTHEAST',
			usps: 'NE'
		},
		S: {
			nena: 'SOUTH',
			usps: 'S'
		},
		SOUTH: {
			nena: 'SOUTH',
			usps: 'S'
		},
		SW: {
			nena: 'SOUTHWEST',
			usps: 'SW'
		},
		SOUTHWEST: {
			nena: 'SOUTHWEST',
			usps: 'SW'
		},
		SE: {
			nena: 'SOUTHEAST',
			usps: 'SE'
		},
		SOUTHEAST: {
			nena: 'SOUTHEAST',
			usps: 'SE'
		},
		E: {
			nena: 'EAST',
			usps: 'E'
		},
		EAST: {
			nena: 'EAST',
			usps: 'E'
		},
		W: {
			nena: 'WEST',
			usps: 'W'
		},
		WEST: {
			nena: 'WEST',
			usps: 'W'
		}
	}

	private _customerProfile: CustomerProfile = {
		discrepancyAgencyId: null,
		// centroidLatlong: null
	};
	// public filterOperatorsByType: {[type in LbColumnType]?: FilterOperatorName[] } = {};

	// public qaRules: QaRule[] = [];

	// UUID which will be used as session id
	// This id will be generated at azgiv component init, and removed at logging out
	private sessionUuid: string;

	constructor(
		private requestService: CommonRequestService,
		private utilityService: CommonUtilityService
		// private uuidService: v1
	) { }

	// getAppinfo(successCallback?, errorCallback?) {
	// 	const url = AppSettings.serviceRootUrl + 'admin/appInfo';
	// 	const params = new URLSearchParams();
	// 	const options = new RequestOptions();
	// 	params.set('application', AppSettings.appName);
	// 	options.params = params;
	// 	this.requestService.requestGet(url, options, (rsp) => {
	// 		this.setLayerTypeList(rsp.data.layer_type_list);
	// 		this.setColumnMap(rsp.data.gdo);
	// 		this.setQaRules(rsp.data.qa_rules);
	// 		if (successCallback) {
	// 			successCallback();
	// 		}
	// 	}, errorCallback);
	// }

	getAppinfo() {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/appInfo';
			const params = {
				applications: JSON.stringify([AppSettings.appName])
			};
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				this.setColumnMap(rsp.data.gdo);
				this.setRoles(rsp.data.roles);
				this.setLayerStateList(rsp.data.azgiv_layer_state);
				this.setFilterOperators(rsp.data.gfo_ui);
				this.setLbDataTypesMap(rsp.data.lb_data_types);
				this.setRefLayerMvtAttrs(rsp.data.ref_layer_mvt_attrs);
				this.setSampleAddresses(rsp.data.azgiv_addr_examples);
				this.setNagParams(rsp.data.nag_addition_params);
				this.setNagPostypeCrosswalk(rsp.data.nag_postype_crosswalk);
				// this.setQaRules(rsp.data.qa_rules);
				console.log('app info obtained.');
				resolve();
			}, () => {
				reject();
			});
		});
	}
	getAppinfoByCustomer(customerId) {
		return new Promise<void>((resolve, reject) => {
			// resolve()
			const url = AppSettings.serviceRootUrl + 'admin/customerAppInfo';
			const params = {
				application: AppSettings.appName,
				customerId: customerId
			};
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				this.setLayerTypeList(rsp.data.layer_type_list);
				this.setReportTypeList(rsp.data.report_type_list);
				this.setCustomerProfile(rsp.data.customer_profile);
				resolve();
			}, () => {
				reject();
			});
		});
	}

	getSessionUuid() {
		return this.sessionUuid;
	}
	generateSessionUuid() {
		this.sessionUuid = uuid();
	}

	// Set layerTypeList
	private setLayerTypeList(data: any[]): void {
		if (!data) {
			console.log('No layer_type_list provided.');
			return;
		}
		this.layerTypeList = [];
		data.forEach((d) => {
			const tableName = d.glt_table_name;
			const col = Object.keys(this.columnMap).find(c => this.columnMap[c].sourceTab === tableName) || '';
			const prefix = col.split('_')[0];
			this.layerTypeList.push({
				name: d.glt_name,
				nameShort: d.glt_name_short,
				code: d.glt_cd,
				id: d.glt_id,
				geomType: d.glt_geom_type,
				scope: d.glt_scope,
				status: d.glt_status,
				definedBy: d.glt_defined_by,
				parentTypeCode: d.glt_parent_cd,
				hasCommon: d.glt_common,
				tableName: tableName,
				isCollaborative: d.gtc_collaborative,
				isStateMaintained: d.gtc_state_maintained,
				colPrefix: prefix
			});
		});
	}
	private setReportTypeList(data: any[]): void {
		if (!data) {
			console.log('No report_type_list provided.');
			return;
		}
		this.reportTypeList = [{
			label: 'ALL',
			value: 'ALL'
		}];
		data.forEach((d) => {
			this.reportTypeList.push({
				label: d.gqr_types,
				value: d.gqr_types
			});
		});
	}
	private setCustomerProfile(data: any[]) {
		if (!data || !data[0]) {
			return;
		}
		this._customerProfile.discrepancyAgencyId = data[0].cus_discrp_ag_id;
		// if (data[0].cus_centroid) {
		// 	const centroidRaw = data[0].cus_centroid.split(' ');
		// 	this._customerProfile.centroidLatlong = [Number(centroidRaw[1]), Number(centroidRaw[0])];
		// }
	}
	get customerProfile(): CustomerProfile {
		return JSON.parse(JSON.stringify(this._customerProfile));
	}

	private setColumnMap(data: {count: number, result: any[]}): void {
		if (!data) {
			console.log('No Gdo Info.');
			return;
		}
		// convert Gdo data to columnMap
		for (let i = 0; i < data.result.length; i++) {
			this.columnMap[data.result[i].col_name] = {
				name: data.result[i].col_name, // column name
				heading: data.result[i].col_heading, // column displayed name
				width: data.result[i].col_size,
				type: data.result[i].col_type,
				sourceTab: data.result[i].src_tab, // source tab
				align: data.result[i].align, // text-align. 'C' for center, 'L' for left, 'R' for right
				isDisplay: data.result[i].display === 'Y' ? true : false , // display or hide column. 'Y' | 'N'
				isPrimeKey: data.result[i].prim_key === 'Y' ? true : false, // is prime key or not
				isGto: data.result[i].gto === 'Y' ? true : false, // ???
				seq: data.result[i].col_seq, // column sequence
				fkCol: data.result[i].fk_col, // Foreign key column name
				fkTab: data.result[i].fk_tab // Foreign key table
			};
		}
	}

	private setRoles(data) {
		if (!data) { return; }
		this.rolesByApp = this.utilityService.arrayToObjectByFirstProp(data);
	}
	private setLayerStateList(data) {
		if (!data) {
			console.log('azgiv_layer_state does not exist.');
			return;
		}
		this.layerStateMap = this.utilityService.arrayToObjectByFirstProp(data);
	}
	private setFilterOperators(data: any[]) {
		if (!data) {
			console.log('No gfo_ui provided.');
			return;
		}
		const typeMapping: { [type: string]: GeneralColType } = {
			t: 'text',
			j: 'jsonb',
			b: 'bool',
			n: 'numeric',
			d: 'date',
			u: 'uuid'
		}
		data.forEach((d) => {
			if (!this.filterOperators[d.op]) {
				this.filterOperators[(<FilterOperatorName>d.op)] = {
					name: d.op,
					label: d.lbl,
					sq: d.seq,
					compatibleColTypes: [],
				}
			}
			this.filterOperators[d.op].compatibleColTypes.push(typeMapping[d.typ]);
		});
		// // 'is empty' and 'not empty' are not in the database. Add them manually
		// this.filterOperators['is empty'] = {
		// 	name: 'is empty',
		// 	label: 'isEmpty',
		// 	compatibleColTypes: ['text']
		// }
		// this.filterOperators['not empty'] = {
		// 	name: 'not empty',
		// 	label: 'notEmpty',
		// 	compatibleColTypes: ['text']
		// }
	}
	private setLbDataTypesMap(data) {
		if (!data) {
			console.log('No gfo_data_types provided.');
			return;
		}
		this.lbDataTypesMap = data;
	}
	private setRefLayerMvtAttrs(data) {
		if (!data) {
			console.log('No ref_layer_mvt_attrs provided.');
			return;
		}
		data.forEach(d => {
			if (!this.refLayerMvtAttrs[d.ref_layer]) {
				this.refLayerMvtAttrs[d.ref_layer] = {};
			}
			this.refLayerMvtAttrs[d.ref_layer][d.model] = {
				model: d.model,
				attrList: d.attr_list
			}
		});
	}

	private setSampleAddresses(data) {
		if (!data) {
			console.log('No azgiv_addr_examples provided.');
			return;
		}
		this.sampleAddresses = data;
	}
	private setNagParams(data: any[]) {
		if (!data) {
			return
		}
		this.nagParams = data.map(i => {
			return {
				standardName: i.gss_col_name,
				nctId: i.nct_id,
				isSpatial: i.is_spatial,
				source: i.source,
				nctName: i.gss_nct_name // TODO
			}
		})
	}
	private setNagPostypeCrosswalk(data: any[]) {
		if (!data) {
			return
		}
		this.nagPostypeCrosswalk = {};
		data.forEach(i => {
			this.nagPostypeCrosswalk[i.street_postyp] = {
				postType: i.street_postyp,
				nena: i.nena_postyp,
				usps: i.usps_postyp,
				cusId: i.cus_id
			}
		});
	}

	public findGeneralCol(lbColType: string) {
		if (!lbColType) {
			return;
		}
		let generalColType: GeneralColType;
		for (const t of Object.keys(this.lbDataTypesMap)) {
			if (this.lbDataTypesMap[t].indexOf(lbColType.toLowerCase()) !== -1) {
				generalColType = (<GeneralColType>t);
				break;
			}
		}
		if (!generalColType && lbColType.toLowerCase().startsWith('timestamp')) {
			generalColType = 'date';
		}
		return generalColType;
	}
}
